import styled, { keyframes } from 'styled-components'
import { theme } from '../../styles'

const sheetin = keyframes`
  from { transform: translateY(100%); }
  to { transform: none; }
`

export const Scrim = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(20, 22, 48, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 100;
  font-family: ${theme.fontes.sans};
  color: ${theme.cores.inkDeep};

  ${theme.mobile} {
    padding: 0;
    align-items: flex-end;
    background: rgba(12, 14, 36, 0.55);
  }
`

export const ModalBox = styled.div`
  background: ${theme.cores.card};
  border-radius: ${theme.raio.lg};
  box-shadow: ${theme.sombras.lg};
  width: 100%;
  max-width: ${( { $wide } ) => ( $wide ? '660px' : '520px' )};
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${theme.mobile} {
    max-width: 100%;
    max-height: 90%;
    border-radius: 24px 24px 0 0;
    padding-bottom: 8px;
    position: relative;
    animation: ${sheetin} 0.32s cubic-bezier(0.2, 0.8, 0.25, 1);

    &::before {
      content: '';
      position: absolute;
      top: 9px;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 4px;
      border-radius: 99px;
      background: ${theme.cores.lineStrong};
    }
  }
`

export const ModalHead = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 24px 26px 16px;
  border-bottom: 1px solid ${theme.cores.line};

  ${( { $bare } ) => ( $bare
    ? 'padding-bottom: 0; border-bottom: none;'
    : '' )}

  ${theme.mobile} {
    padding: ${( { $bare } ) => ( $bare ? '26px 22px 0' : '26px 22px 14px' )};
  }
`

export const ModalHeadInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: ${theme.cores.inkFaint};
`

export const ModalTitle = styled.h2`
  margin: 0;
  color: ${theme.cores.navy};
  font-size: 23px;
  font-weight: 700;
  line-height: 1.1;

  ${theme.mobile} {
    font-size: 21px;
  }
`

export const ModalSub = styled.p`
  margin: 4px 0 0;
  color: ${theme.cores.inkSoft};
  font-size: 13.5px;
  line-height: 1.45;
`

export const Steps = styled.div`
  display: flex;
  gap: 7px;
  margin-top: 10px;
`

export const StepDot = styled.i`
  height: 4px;
  flex: 1;
  border-radius: 2px;
  background: ${( { $on } ) => ( $on ? theme.cores.accent : theme.cores.lineStrong )};
`

export const CloseButton = styled.button`
  flex: none;
  margin-left: auto;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  border: 1px solid ${theme.cores.line};
  background: ${theme.cores.paperAlt};
  color: ${theme.cores.inkSoft};
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;

  &:hover {
    background: ${theme.cores.paper};
    color: ${theme.cores.inkDeep};
  }
`

export const ModalBody = styled.div`
  padding: 22px 26px;
  overflow-y: auto;
  color: ${theme.cores.inkDeep};

  ${theme.mobile} {
    padding: 18px 22px;
  }
`

export const ModalFoot = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 26px 24px;
  border-top: 1px solid ${theme.cores.line};
  background: ${theme.cores.card};
  flex-wrap: wrap;

  ${theme.mobile} {
    padding: 14px 22px calc(16px + env(safe-area-inset-bottom));
    gap: 10px;
    position: sticky;
    bottom: 0;
    background: ${theme.cores.card};

    & > button,
    & > a {
      flex: 1 1 auto;
      min-width: 0;
      min-height: 48px;
    }

    & > span {
      display: none;
    }
  }
`
